import { useMutation } from "react-query";
import signedDocument from "../services/signedDocument";

function useSignedDocument() {
  return useMutation(["signed-document"], signedDocument);
}

export default useSignedDocument;
